<template>
  <div id="password-canvas"
       :class="{'clear': organization && !organization.darkMode}"
       class="offcanvas offcanvas-right"
    v-click-outside="close">
    <!--begin::Header-->
    <div class="offcanvas-header d-flex align-items-center justify-content-between pb-2">
      <div class="d-flex align-items-center">
          <span class="font-weight-light" style="font-size: 2.5rem">
              {{$t('profile.change.password')}}
          </span>
      </div>
      <a href="#" class="btn btn-xs btn-icon btn-hover-primary ml-auto"
         @click="close">
        <inline-svg :src="require('@/assets/images/icons/Icon_Cancel.svg')"
                    width="20" height="20"/>
      </a>
    </div>
    <!--end::Header-->
    <!--begin::Content-->
    <div class="offcanvas-content px-4 px-md-7">
      <div class="profile-info mt-5">
        <form @submit.prevent="updatePassword">
          <div class="form-group"
               :class="{'validated' : this.isWrongPassword}"
          >
            <label>{{$t('profile.password.actual')}}</label>
            <input type="password" v-model="password" class="form-control form-control-sm"
                   @keyup="this.handleOldPasswordChange"
                   :class="{
                        'is-invalid' : this.isWrongPassword,
                      }"
            required>
            <div class="invalid-feedback" :v-if="this.isWrongPassword">
              {{$t('profile.password.error')}}
            </div>
          </div>
          <div class="form-group" :class="{'validated' : this.newPassword && this.isWeakPassword}">
            <label>{{$t('profile.password.new')}}</label>
            <input type="password" v-model="newPassword" class="form-control form-control-sm"
                   :class="{
                        'is-invalid' : this.newPassword && this.isWeakPassword,
                       'is-valid': this.newPassword && !this.isWeakPassword
                      }"
                   @keyup="handlePasswordChange"
            required>
            <div class="invalid-feedback" :v-if="this.newPassword && this.isWeakPassword">
              {{$t('profile.password.complexity.error')}}
            </div>
          </div>
          <div class="form-group" :class="{'validated' : this.newPassword
                        && this.confirmPassword
                        && !this.isSamePassword}">
            <label> {{$t('profile.password.confirm')}}</label>
            <input type="password" class="form-control form-control-sm"
                   v-model="confirmPassword"
                   @keyup="handlePasswordChange"
                   :class="{
                        'is-invalid' : this.newPassword
                        && this.confirmPassword
                        && !this.isSamePassword,
                        'is-valid' : this.newPassword
                        && !this.isWeakPassword
                        && this.confirmPassword
                        && this.isSamePassword
                      }"
            >
            <div class="invalid-feedback" :v-if="this.newPassword
                        && this.confirmPassword
                        && !this.isSamePassword">
              {{$t('profile.password.confirmation.error')}}
            </div>
          </div>
          <div class="d-flex flex-column mt-5">
            <button type="submit" class="btn btn-primary btn-sm px-8 text-uppercase mb-2">
              {{$t('profile.change.password')}}
            </button>
            <button type="button"
                    class="btn btn-outline-primary btn-sm px-8 text-uppercase"
                    @click="close">
              {{$t('app.button.cancel')}}
            </button>
          </div>
        </form>
      </div>
    </div>
    <!--end::Content-->
  </div>
</template>
<script>
import { UPDATE_PASSWORD } from '@/store/actions.type';
import { mapGetters } from 'vuex';
import HelperMixin from '@/mixins/helperMixin';

export default {
  name: 'PasswordCanvas',
  mixins: [HelperMixin],
  computed: {
    ...mapGetters(['currentUser', 'organization']),
    isError() {
      return !this.newPassword || !this.confirmPassword
        || !this.password || !this.isSamePassword
        || this.isWeakPassword;
    },
  },
  data() {
    return {
      password: '',
      newPassword: '',
      confirmPassword: '',
      errors: [],
      isWeakPassword: false,
      isSamePassword: false,
      isWrongPassword: false,
    };
  },
  methods: {
    close() {
      if (document.getElementById('password-canvas').classList.contains('offcanvas-on')) {
        this.$emit('close');
      }
    },
    handleOldPasswordChange() {
      this.isWrongPassword = false;
    },
    handlePasswordChange() {
      const { confirmPassword, newPassword } = this;

      // check new password complexity
      if (newPassword) {
        this.isWeakPassword = !this.validatePassword(newPassword);
      }
      // check same confirm password
      if (confirmPassword) {
        this.isSamePassword = confirmPassword === newPassword;
      }

      return this.isWeakPassword && this.isSamePassword;
    },
    updatePassword() {
      const { password, newPassword } = this;

      this.$store.dispatch(UPDATE_PASSWORD, { password, newPassword }).then(() => {
        this.$toasted.success(this.$t('profile.edit.message.success'));
        this.$Progress.finish();
        this.close();
      }).catch((error) => {
        if (error.response && error.response.data.response.code === 4011) {
          this.isWrongPassword = true;
        }
        this.$toasted.error(this.$t('app.message.error'));
      });

      return true;
    },
  },
};
</script>
